import React from 'react';

function RadioSelection(props) {

    return (
        <>
            <form>
                {
                    props.options.map((option, index) => {
                        return (
                            <div key={`${index}`} className="form-check">
                                <label className="radio-container">
                                    <input
                                        type="radio"
                                        value={option.value}
                                        checked={option.value === props.selected}
                                        onChange={(changeEvent) => {
                                            props.onChange(changeEvent.target.value);
                                        }}
                                        className="form-check-input"
                                    />
                                    <span className="radio"/>
                                    {option.label}
                                </label>
                            </div>
                        );
                    })
                }
            </form>
        </>
    );
}

export default RadioSelection;
